const tabs = () => (
  [MANAGE_PRODUCTS, MY_MEDIA, MANAGE_RESELLERS]
)

export default {
  get tabs() { return tabs() }
}

//
const MANAGE_PRODUCTS = {
  label: 'Manage Products',
  href: { params: { page: 'Programs', section: 'Products', action: 'MyProduct' } }
}

const MY_MEDIA = {
  label: 'My Media',
  href: { params: { page: 'Programs', section: 'Products', action: 'MyMedia' } }
}

const MANAGE_RESELLERS = {
  label: 'Manage Resellers',
  href: { params: { page: 'Programs', section: 'Products', action: 'ManageReseller' } }
}



// WEBPACK FOOTER //
// ./src/components/_modules/Products/tabs.js